// extracted by mini-css-extract-plugin
module.exports = {"box":"FJTextAreaBox_box__X5WzM","textarea":"FJTextAreaBox_textarea__1_Pjc"};